<template>
      <div class="container my-5 pt-3 h-100">
        <div class="row h-100">
            <div class="col-12 p-0 text-center" style="max-height: 720px;">
                <img src="../assets/login.png" alt="" style="height:50%;" />
                <h5 class="font-weight-light mb-3">Please register your identity</h5>
                <div class="row">
                <div class="col-md-6 mx-auto">
                    <form @submit.prevent="doRegister">
                        <div class="form-group">
                            <input type="text" class="form-control" v-model='name' placeholder="Enter your name" />
                        </div>
                        <div class="form-group">
                            <input type="email" class="form-control" v-model='email' placeholder="Enter your email" />
                        </div>
                        <div class="form-group">
                            <input type="password" class="form-control" v-model='password' placeholder="Enter your password" />
                        </div>
                        <button type="submit" class="btn btn-primary btn-block">Register</button>
                        <button type="button" @click="cancelRegister" class="btn btn-danger btn-block">Cancel</button>
                    </form>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import swal from 'sweetalert'

export default {
    name: 'Register',
    data() {
        return {
            name: '',
            email: '',
            password: '',
            // url: 'http://localhost:3000'
            url: 'https://dry-savannah-57278.herokuapp.com'
        }
    },
    methods: {
        doRegister(){
            axios({
               url: `${this.url}/auth/register`,
               method: 'post',
               data: {
                   name: this.name,
                   email: this.email,
                   password: this.password
               }
           })
           .then(done=>{
               if(done){
                   console.log(done.data)
                   return  axios({
                        url: `${this.url}/auth/login`,
                        method: 'post',
                        data: {
                            email: this.email,
                            password: this.password
                        }
                    })
               }
           })
            .then(response=>{
              localStorage.setItem('token',response.data.token)
              localStorage.setItem('name',response.data.name)
              this.$store.commit('LOGIN')
              this.$router.replace({name:'Home'})
              swal('Thanks!','Register success','success')
            })
            .catch(err=>{
               swal("Error!",err.response.data.message,"error")
            })
        },
        resetForm() {
           this.email = "",
           this.password= ""
        },
        cancelRegister() {
          this.$router.go(-1)
        }
    }
}
</script>